import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const RectangleListIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 20"
      >
        <path
          fill="currentColor"
          d="M.459 16.29c0 1.899.976 2.883 2.856 2.883h9.36c1.882 0 2.857-.984 2.857-2.883V3.027c0-1.89-.975-2.882-2.856-2.882h-9.36C1.434.145.458 1.138.458 3.027zm1.723-.105V3.133c0-.818.422-1.266 1.274-1.266h9.07c.853 0 1.284.448 1.284 1.266v13.052c0 .817-.431 1.265-1.284 1.265h-9.07c-.852 0-1.274-.448-1.274-1.265M4.256 5.163c.457 0 .817-.37.817-.817a.81.81 0 0 0-.817-.818.82.82 0 0 0-.818.818c0 .448.37.817.818.817m2.417-.246h5.308a.57.57 0 1 0 0-1.143H6.673a.57.57 0 1 0 0 1.143M4.256 7.782c.457 0 .817-.369.817-.817a.803.803 0 0 0-.817-.809.81.81 0 0 0-.818.809c0 .448.36.817.818.817m2.417-.246h5.308a.565.565 0 0 0 .572-.571.557.557 0 0 0-.572-.563H6.673a.557.557 0 0 0-.571.563c0 .316.246.571.57.571m-2.417 2.997c.457 0 .817-.369.817-.817a.82.82 0 0 0-.817-.826.83.83 0 0 0-.818.826c0 .44.37.817.818.817m2.417-.246h5.308a.576.576 0 0 0 .572-.571.565.565 0 0 0-.572-.571H6.673a.565.565 0 0 0-.571.57c0 .308.254.572.57.572"
        ></path>
      </svg>
    </div>
  );
};

export default RectangleListIcon;
